import { SelectOption } from './helpers';
import { HostingType, SalesTeamType, TeamAccessType } from './types';

export interface RadioOption<T> {
  value: T;
  label: string;
  description: string;
}

export const IP_VERSION_OPTIONS: SelectOption[] = [
  { value: 'ipv4', label: 'IPv4' },
  { value: 'ipv6', label: 'IPv6' },
];

export const RELATION_OPTIONS: SelectOption[] = [
  { value: 'funcionario', label: 'Funcionário da empresa' },
  { value: 'terceirizado', label: 'Profissional ou empresa terceirizada' },
  { value: 'fornecedor_sistema', label: 'Fornecedor do sistema que vai receber as licitações' },
  { value: 'outro', label: 'Outro' },
];

export const SALES_TEAM_OPTIONS: RadioOption<Exclude<SalesTeamType, ''>>[] = [
  { value: 'intermediario', label: 'Intermediário', description: 'representante terceirizado' },
  {
    value: 'equipe_propria',
    label: 'Equipe própria',
    description: 'departamento interno de licitações',
  },
  {
    value: 'ambas',
    label: 'Ambas as situações',
    description: 'profissionais terceirizados e profissionais próprios',
  },
];

export const TEAM_ACCESS_OPTIONS: RadioOption<Exclude<TeamAccessType, ''>>[] = [
  { value: 'remotamente', label: 'Remotamente', description: 'durante trabalho externo' },
  {
    value: 'localmente',
    label: 'Localmente',
    description: 'dentro das dependências da sua empresa',
  },
  {
    value: 'ambas',
    label: 'Ambas as situações',
    description: 'acessam localmente e remotamente',
  },
];

export const FREQUENCY_OPTIONS: SelectOption[] = [
  { value: '1x_dia', label: '1 vez ao dia' },
  { value: '2x_dia', label: '2 vezes ao dia' },
  { value: '3x_dia', label: '3 vezes ao dia (recomendado)' },
];

export const HOSTING_OPTIONS: Array<{ value: Exclude<HostingType, ''>; label: string }> = [
  { value: 'operadora', label: 'Operadora de internet' },
  { value: 'nuvem', label: 'Servidor em nuvem' },
];
